import React from "react";
import {connect} from "react-redux";
import {formValueSelector, reduxForm} from "redux-form";
import {ff, form} from "@mc/mc-legacy";
import EnumSealSource from "../../api/gen/qsign/types/EnumSealSource";
import EnumSealLevel from "../../api/gen/qsign/types/EnumSealLevel";
import EnumTimestampSource from "../../api/gen/qsign/types/EnumTimestampSource";
import EnumTimestampLevel from "../../api/gen/qsign/types/EnumTimestampLevel";

const {Form, FormActions, FormBody} = form;

const validate = (formData) => {
    const errors = {};

    if (!formData.connectorName) {
        errors.connectorName = "Název musí být vyplněný";
    }

    if (!formData.connectorOrder) {
        errors.connectorOrder = "Pořadí musí být vyplněné";
    }

    if (formData.connectorOrder < 1) {
        errors.connectorOrder = "Pořadí musí být větší než 0";
    }
    if (!formData.level) {
        errors.level = "Úroveň musí být vyplněná";
    }

    if (!formData.source) {
        errors.source = "Typ musí být vyplněný";
    }

    if (formData.source === "REMSIG") {
        if (!formData.login) {
            errors.login = "Login musí být vyplněný";
        }

        if (!formData.url) {
            errors.url = "URL musí být vyplněná";
        }

        if (!formData.password) {
            errors.password = "Heslo musí být vyplněné";
        }

        if (!formData.personUniqueId) {
            errors.personUniqueId = "Unikátni ID musí být vyplněné";
        }

        if (!formData.certPassword) {
            errors.certPassword = "Heslo k certifikátu musí být vyplněné";
        }
    }

    if (formData.source === "QSEAL") {
        if (!formData.login) {
            errors.login = "Přihlašovací jméno musí být vyplněné";
        }

        if (!formData.url) {
            errors.url = "URL musí být vyplněná";
        }

        if (!formData.password) {
            errors.password = "Heslo musí být vyplněné";
        }
    }

    if (formData.source === "MC") {
        if (!formData.certPath) {
            errors.certPath = "Cesta k certifikátu musí být vyplněná";
        }

        if (!formData.certPassword) {
            errors.certPassword = "Heslo k certifikátu musí být vyplněné";
        }
    }

    if (formData.source === "ICA") {
        if (!formData.certPath) {
            errors.certPath = "Cesta k aktivačnímu souboru musí být vyplněná";
        }
    }

    if (formData.razitko) {
        if (!formData.razitkoConnectorName) {
            errors.razitkoConnectorName = "Název musí být vyplněný";
        }

        if (!formData.levelRazitko) {
            errors.levelRazitko = "Úroveň musí být vyplněná";
        }

        if (!formData.sourceRazitko) {
            errors.sourceRazitko = "Typ musí být vyplněný";
        }

        if (formData.sourceRazitko == EnumTimestampSource.TSA && !formData.tsUrl) {
            errors.tsUrl = "Url adresa musí být vyplněná";
        }
    }
    return errors;
};

class PeceteniForm extends React.Component {
    static formName = "PeceteniForm";
    mcItemsSourceRazitko = [
        {
            id: EnumTimestampSource.TSA,
            name: "TSA",
        }
    ];
    itemsSourceRazitko = [
        {
            id: EnumTimestampSource.TSA,
            name: "TSA",
        },
        {
            id: EnumTimestampSource.REMSIG,
            name: "Remsig",
        },
    ];
    itemsLevelRazitko = [
        {
            id: EnumTimestampLevel.QUALIFIED,
            name: "Kvalifikovaný",
        },
        {
            id: EnumTimestampLevel.GUARANTEED,
            name: "Zaručený",
        },
    ];
    itemsSeal = [
        {id: EnumSealLevel.QUALIFIED, name: "Kvalifikovaný"},
        {id: EnumSealLevel.GUARANTEED, name: "Zaručený"},
    ];
    kvalifikovanyItems = [
        {
            id: EnumSealSource.REMSIG,
            name: "Remsig",
        },
        {
            id: EnumSealSource.ICA,
            name: "ICA",
        },
        {
            id: EnumSealSource.SECUSIGN,
            name: "SecuSign",
        },
        {
            id: EnumSealSource.QSEAL,
            name: "QSeal",
        },
    ];
    zarucenyItems = [
        {
            id: EnumSealSource.MC,
            name: "Marbes",
        },
    ];
    vratItems = () => {
        return this.props.level == EnumSealLevel.QUALIFIED ? this.kvalifikovanyItems : this.zarucenyItems;
    };

    isRemsig() {
        return this.props.source && this.props.source == EnumSealSource.REMSIG;
    }

    isMC() {
        return this.props.source && this.props.source == EnumSealSource.MC;
    }

    isICA() {
        return this.props.source && this.props.source == EnumSealSource.ICA;
    }

    isQSeal() {
        return this.props.source && this.props.source == EnumSealSource.QSEAL;
    }

    isRemsigTlacitko() {
        return this.props.sourceRazitko && this.props.sourceRazitko == EnumTimestampSource.REMSIG;
    }

    isTSA() {
        return this.props.sourceRazitko && this.props.sourceRazitko == EnumTimestampSource.TSA;
    }

    isSecuSign() {
        return this.props.source && this.props.source == EnumSealSource.SECUSIGN;
    }

    onChangeTyp(typ) {
        this.props.change("url", null);
        this.props.change("login", null);
        this.props.change("password", null);
        this.props.change("personUniqueId", null);
        this.props.change("password", null);
        this.props.change("certPath", null);
        this.props.change("certPassword", null);
        //  this.props.change("CestaKAktivacnimuSouboru", null);
        this.props.change("razitko", false);
    }

    onChangeRazitko() {
        this.props.change("levelRazitko", null);
        this.props.change("sourceRazitko", null);
        this.props.change("razitkoConnectorName", null);
        this.onChangeTypRazitko();
    }

    onChangeTypRazitko() {
        this.props.change("tsUrl", null);
        this.props.change("tsLogin", null);
        this.props.change("tsPassword", null);
        this.props.change("tsCertPath", null);
        this.props.change("tsCertPassword", null);
        this.props.change("tsTimeout", null);
    }

    render() {
        const {onClose, submitting, handleSubmit, values} = this.props;
        return (
            <Form onSubmit={handleSubmit}>
                <FormBody>
                    <ff.String name="connectorName" required label="Název"/>
                    {this.props.connectorName &&
                        <ff.Number int name="connectorOrder" required min={1} max={5} label="pořadí"/>}
                    {this.props.connectorOrder && (
                        <ff.Autocomplete required name="level" label="Úroveň" useIdAsValue={true}
                                         items={this.itemsSeal}/>
                    )}
                    {this.props.level && (
                        <ff.Autocomplete
                            required
                            name="source"
                            label="Typ"
                            useIdAsValue={true}
                            onChange={(typ) => {
                                this.onChangeTyp(typ);
                            }}
                            items={this.vratItems()}
                        />
                    )}
                    {this.isRemsig() && (
                        <div>
                            <ff.String required name="url" label="Url"/>
                            <ff.String required name="login" label="Přihlašovací jméno"/>
                            <ff.String required name="password" type="password" label="Heslo"/>
                            <ff.String required name="personUniqueId" labe="ID uživatele"/>
                            <ff.String required name="certPassword" type="password" label="Heslo k certifikátu"/>
                        </div>
                    )}
                    {this.isMC() && (
                        <div>
                            <ff.String required name="certPath" label="Cesta k certifikátu"/>
                            <ff.String required name="certPassword" type="password" label="Heslo k certifikátu"/>
                        </div>
                    )}
                    {this.isICA() && <ff.String name="certPath" label="Cesta k aktivačnímu souboru"/>}
                    {this.isSecuSign() && (
                        <div>
                            <ff.String required name="url" label="Url"/>
                            <ff.String required name="login" label="Přihlašovací jméno"/>
                            <ff.String required name="password" type="password" label="Heslo"/>
                        </div>
                    )}
                    {this.isQSeal() && (
                        <div>
                            <ff.String required name="url" label="Url"/>
                            <ff.String required name="login" label="Přihlašovací jméno"/>
                            <ff.String required name="password" type="password" label="Heslo"/>
                        </div>
                    )}
                    {this.props.source && (
                        <ff.Checkbox
                            name="razitko"
                            onChange={() => {
                                this.onChangeRazitko();
                            }}
                            label="Připojení časového razítka"
                        />
                    )}
                </FormBody>
                {this.props.razitko && (
                    <FormBody>
                        <ff.String
                            required
                            name="razitkoConnectorName"
                            label="název"/>
                        {this.props.razitkoConnectorName && (
                            <ff.Autocomplete
                                required
                                useIdAsValue={true}
                                name="levelRazitko"
                                label="Úroveň"
                                items={this.itemsLevelRazitko}
                            />
                        )}
                        {this.props.levelRazitko && (
                            <ff.Autocomplete
                                required
                                name="sourceRazitko"
                                label="Typ"
                                useIdAsValue={true}
                                onChange={() => this.onChangeTypRazitko()}
                                items={this.isMC() ? this.mcItemsSourceRazitko : this.itemsSourceRazitko}
                            />
                        )}
                        {this.isTSA() && (
                            <div>
                                <ff.String required name="tsUrl" label="Url"/>
                                <ff.String name="tsLogin" label="Přihlašovací jméno"/>
                                <ff.String name="tsPassword" type="password" label="Heslo"/>
                                <ff.String disabled={this.isQSeal()} name="tsCertPath" label="Cesta k certifikátu"/>
                                <ff.String disabled={this.isQSeal()} name="tsCertPassword" type="password" label="Heslo k certifikátu"/>
                            </div>
                        )}
                        {this.isRemsigTlacitko() && (
                            <div>
                                <ff.String name="tsUrl" label="Url"/>
                                <ff.String name="tsLogin" label="Přihlašovací jméno"/>
                                <ff.String name="tsPassword" type="password" label="Heslo"/>
                                <ff.String name="tsTimeout" label="tsTimeout"/>
                            </div>
                        )}
                    </FormBody>
                )}
                <FormActions onClose={onClose} storeButton cancelButton disabled={submitting}/>
            </Form>
        );
    }
}

function mapStateToProps(state) {
    const selector = formValueSelector(PeceteniForm.formName);
    return {
        connectorId: selector(state, "connectorId"),
        connectorName: selector(state, "connectorName"),
        level: selector(state, "level"),
        source: selector(state, "source"),
        connectorOrder: selector(state, "connectorOrder"),
        razitko: selector(state, "razitko"),
        levelRazitko: selector(state, "levelRazitko"),
        sourceRazitko: selector(state, "sourceRazitko"),
        url: selector(state, "url"),
        login: selector(state, "login"),
        password: selector(state, "password"),
        certPath: selector(state, "certPath"),
        certPassword: selector(state, "certPassword"),
        personUniqueId: selector(state, "personUniqueId"),
        tsUrl: selector(state, "tsUrl"),
        loginRazikto: selector(state, "loginRazikto"),
        tsPassword: selector(state, "tsPassword"),
        tsCertPath: selector(state, "tsCertPath"),
        tsCertPassword: selector(state, "tsCertPassword"),
        tsTimeout: selector(state, "tsTimeout"),
        tsConnectorId: selector(state, "tsConnectorId"),
        razitkoConnectorName: selector(state, "razitkoConnectorName"),
    };
}

export default connect(mapStateToProps)(
    reduxForm({
        form: PeceteniForm.formName,
        validate: validate,
    })(PeceteniForm)
);
